import { render, staticRenderFns } from "./ETH.vue?vue&type=template&id=1fbea4f2&scoped=true&"
import script from "./ETH.vue?vue&type=script&lang=js&"
export * from "./ETH.vue?vue&type=script&lang=js&"
import style0 from "./ETH.vue?vue&type=style&index=0&id=1fbea4f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbea4f2",
  null
  
)

export default component.exports